import { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";

const sections = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "themes", label: "Themes" },
    { id: "timeline", label: "Timeline" },
    { id: "past", label: "Gallery" },
    { id: "sponsors", label: "Prizes" },
    { id: "contact", label: "Our Team" },
    { id: "faq", label: "FAQ'S" },
];

export default function Navbar() {
    const [active, setActive] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false); // State for mobile menu
    const linksRef = useRef(null);
    const indicatorRef = useRef(null);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    /* ================= SCROLL SPY ================= */
    useEffect(() => {
        const sectionEls = sections.map(s => document.getElementById(s.id));
        const onScroll = () => {
            const scrollPos = window.scrollY + window.innerHeight / 3;
            sectionEls.forEach(section => {
                if (!section) return;
                const top = section.offsetTop;
                const height = section.offsetHeight;
                if (scrollPos >= top && scrollPos < top + height) {
                    setActive(section.id);
                }
            });
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    /* ================= SLIDING INDICATOR (Desktop Only) ================= */
    useEffect(() => {
        if (!active || !linksRef.current || !indicatorRef.current || window.innerWidth < 900) return;

        const activeLink = linksRef.current.querySelector(`span[data-id="${active}"]`);
        if (activeLink) {
            indicatorRef.current.style.width = `${activeLink.offsetWidth}px`;
            indicatorRef.current.style.left = `${activeLink.offsetLeft}px`;
        }
    }, [active, menuOpen]);

    /* ================= SCROLL TO SECTION ================= */
    const scrollTo = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
            setMenuOpen(false); // Close menu on click
        }
    };

    return (
        <nav className="navbar">
            {/* BRAND */}
            <div className="brand" onClick={() => scrollTo("home")}>
                <img src={logo} alt="HackKRMU Logo" className="brand-logo" />
                <span className="logo-text">HACK KRMU 5.0</span>
            </div>

            {/* HAMBURGER ICON (Visible on Mobile) */}
            <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>

            {/* LINKS CONTAINER (Desktop Center + Mobile Drawer) */}
            <div ref={linksRef} className={`links center ${menuOpen ? "mobile-active" : ""}`}>
                {sections.map(({ id, label }) => (
                    <span
                        key={id}
                        data-id={id}
                        className={active === id ? "active" : ""}
                        onClick={() => scrollTo(id)}
                    >
                        {label}
                    </span>
                ))}
                {/* Indicator only shows on Desktop via CSS */}
                <span ref={indicatorRef} className="nav-indicator" />

                {/* Mobile-only Register Button (Optional: if you want it inside the menu) */}
                {/* <a href="https://unstop.com/hackathons/hack-krmu-50-kr-mangalam-university-krmu-sohna-road-gurugram-haryana-1626201" className="mobile-register-btn">REGISTER NOW</a> */}
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSekNZkQk8vGmiZZz-RSnHlS4CRsi9BSIocWHc1n5kMMy3dREg/viewform?usp=sharing&ouid=101410070918072268617" className="mobile-register-btn">REGISTER NOW</a>
                {/* <a href="/register" className="mobile-register-btn">REGISTER NOW</a> */}
            </div>

            {/* DESKTOP REGISTER PILL (Hidden on Mobile via CSS) */}
            <a
                // href="/register"
                // href="https://unstop.com/hackathons/hack-krmu-50-kr-mangalam-university-krmu-sohna-road-gurugram-haryana-1626201"
                href="https://docs.google.com/forms/d/e/1FAIpQLSekNZkQk8vGmiZZz-RSnHlS4CRsi9BSIocWHc1n5kMMy3dREg/viewform?usp=sharing&ouid=101410070918072268617"
                target="_blank"
                rel="noopener noreferrer"
                className="register-pill desktop-only">
                REGISTER NOW
            </a>
        </nav>
    );
}
